import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router';
import { AuthState, OAuthProvider } from '../../application/Providers/Authentication/OAuthProvider';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface Props {
    authState: AuthState;
    authService: OAuthProvider;
}

interface State {
    baseUrl: string | undefined;
}

const Login: React.FC = (props) => {
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const [baseUrl, setBaseUrl] = useState<string | undefined>(process.env.REACT_APP_OKTA_BASE);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const history = useHistory();

    const query = useQuery();
    const referer = query.get('referer');

    // const onSuccess = (res: any) => {
    //     return oktaAuth.handleLoginRedirect(res, referer || '');
    // };
    //
    // const onError = () => {
    //     // TODO what to do on login error
    // };

    useEffect(() => {
        if (!isAuthenticated) {
            loginWithRedirect({ appState: { returnTo: referer || '/' } }); // {openUrl:(url)=>history.push(referer || url)}
        }
    }, [isAuthenticated]);

    return (
        <>
            {isAuthenticated ? (
                <Route render={() => <Redirect to={{ pathname: referer || '/' }} />} />
            ) : (
                // this is pulling from the Okta signing page background for Lumen okta...
                // TODO pull this image into the app and use directly
                <div>
                    {/*<div*/}
                    {/*    style={{*/}
                    {/*        background: "url('https://ok7static.oktacdn.com/fs/bco/7/fs0vfrn9c1i7rZCki356')",*/}
                    {/*        backgroundSize: 'cover',*/}
                    {/*        backgroundPosition: '50%',*/}
                    {/*        position: 'absolute',*/}
                    {/*        height: '100vh',*/}
                    {/*        width: '100%',*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <Spacing height={'24px'} />*/}
                    {/*    <OktaSignInWidget baseUrl={baseUrl || ''} onSuccess={onSuccess} onError={onError} />*/}
                </div>
            )}
        </>
    );
};

export default Login;
